<template>
  <el-row :gutter="20">
    <custom-select
      v-model="materialTipo"
      label="Tipo de item"
      :spanColumn="4"
      data-id="CodigoMaterialTipo"
      :settings="{
        placeholder: 'Seleccionar tipo de item',
        filterable: true,
        options: materialTipoList,
      }"
    />
    <custom-select
      v-model="moneda"
      label="Moneda"
      :spanColumn="4"
      :settings="{
        placeholder: 'Seleccionar moneda',
        filterable: true,
        options: monedaList,
      }"
    />
    <custom-select
      v-model="unidadMedida"
      label="Unidad de medida"
      :spanColumn="4"
      :settings="{
        placeholder: 'Seleccionar unidad de medida',
        filterable: true,
        options: unidadesMedida,
      }"
    />
    <custom-select
      v-model="familiaMaterial"
      label="Familia item"
      :spanColumn="4"
      :settings="{
        placeholder: 'Seleccionar familia',
        filterable: true,
        clearable: true,
        options: materiaPrimaFamilias,
      }"
      @click:clearable="handleClearable"
    />
  </el-row>
</template>

<script setup>
import {
  onMounted,
  computed,
  reactive,
  watch,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useMateriaPrimaFamiliaStore } from '@/stores/materia_prima_familia/materia_prima_familia_store.js';
import { useMaterialTipoStore } from '@/stores/material-tipo.js';
import { useMonedaStore } from '@/stores/moneda/moneda_store.js';
import { useUnidadMedidaStore } from '@/stores/unidad_medida/unidad_medida_store.js';
import CustomSelect from '@/shared/components/custom_select.vue';

const materiaPrimaFamiliaStore = useMateriaPrimaFamiliaStore();
const { materiaPrimaFamilias } = storeToRefs(materiaPrimaFamiliaStore);

const materialTipoStore = useMaterialTipoStore();
const { materialTipoList } = storeToRefs(materialTipoStore);

const monedaStore = useMonedaStore();
const { monedaList } = storeToRefs(monedaStore);

const unidadMedidaStore = useUnidadMedidaStore();
const { unidadesMedida } = storeToRefs(unidadMedidaStore);

const props = defineProps({
  params: { type: Object, required: true },
});

const emits = defineEmits(['disabled-button', 'update:modelValue']);

const materialTipo = computed({
  get() {
    return materialTipoList.value.find((mt) => mt.Codigo === props.params.CodigoMaterialTipo);
  },
  set(value) {
    emits('update:modelValue', { value, property: 'CodigoMaterialTipo' });
    checkMandatoryProperties();
  },
});

const moneda = computed({
  get() {
    return monedaList.value.find((mt) => mt.Codigo === props.params.CodigoMoneda);
  },
  set(value) {
    emits('update:modelValue', { value, property: 'CodigoMoneda' });
    checkMandatoryProperties();
  },
});

const unidadMedida = computed({
  get() {
    return unidadesMedida.value.find((mt) => mt.Codigo === props.params.CodigoUnidadMedida);
  },
  set(value) {
    emits('update:modelValue', { value, property: 'CodigoUnidadMedida' });
    checkMandatoryProperties();
  },
});

const familiaMaterial = computed({
  get() {
    return materiaPrimaFamilias.value.find((mt) => mt.Codigo === props.params.CodigoFamilia);
  },
  set(value) {
    emits('update:modelValue', { value, property: 'CodigoFamilia' });
  },
});

const checkMandatoryProperties = () => {
  const { CodigoMaterialTipo, CodigoMoneda, CodigoUnidadMedida } = props.params;
  if (CodigoMaterialTipo > 0 && CodigoMoneda > 0 && CodigoUnidadMedida > 0) {
    emits('disabled-button', false);
  } else {
    emits('disabled-button', true);
  }
};

const handleClearable = () => {
  emits('update:modelValue', { value: null, property: 'CodigoFamilia' });
};

onMounted(async () => {
  checkMandatoryProperties();
  materialTipoStore.emptyList();
  await materialTipoStore.findAllMaterialTipoHTTP({ page: 0, sortBy: 'Descripcion', sort: 'Asc' });
  monedaStore.emptyList();
  await monedaStore.findAllMonedaHTTP({ page: 0, sortBy: 'Descripcion', sort: 'Asc' });
  unidadMedidaStore.emptyList();
  await unidadMedidaStore.findAllUnidadMedidaHTTP({ page: 0, sortBy: 'Descripcion', sort: 'Asc' });
  materiaPrimaFamiliaStore.emptyList();
  await materiaPrimaFamiliaStore.findAllfamiliaMaterialHTTP({
    page: 0,
    sortBy: 'Descripcion',
    sort: 'Asc',
  });
});
</script>
